import { BlockBasic } from "../_models/models.js"

export default class BlockShape extends BlockBasic {
  constructor(block) {
    super(block)
    this.type = "shapeCallout"
    this.size.width = 600
    this.size.height = 400
    this.data = {
      controls: {
        radius: 0.1,
        extremeX: 0.1,
        extremeY: 1.5
      },
      style: {
        fill: "#000000ff",
        stroke: "#000000ff",
        strokeWidth: 3
      }
    }
  }
}
